// extracted by mini-css-extract-plugin
module.exports = {"footer":"MutateMid_footer__3rR0h","legacyBtn":"MutateMid_legacyBtn__36qJ6"};